module.exports = require("@swa-ui/dotcom/src/placements/DestinationByOriginPlacement/DestinationByOriginPlacement.module.scss");